import spacing from 'theme/config/spacing';
import { Color, FontWeight, Value } from 'theme/style';
import typography from 'theme/config/typography'

export default {
  'root': {
    ...typography.h6,
    height: '36px',
    minHeight: '36px',
    minWidth: '0 !important',
    marginRight: spacing(2),
    padding: spacing(1),
    position: 'relative',
    color: Color.TextSecondary,
    fontWeight: FontWeight.SemiBold,
    borderRadius: Value.BorderRadius
  },
  'textColorInherit': {
    '&:hover': {
      backgroundColor: '#E6E7EA',
    },
    '&$selected': {
      color: Color.White,
      backgroundColor: Color.Primary,
      '&:hover': {
        backgroundColor: Color.Primary,
      },
    }
  }
};
